import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";

export function CouponsPage() {
    return (
        <div className="space-y-6">
            <h2 className="text-3xl font-bold tracking-tight">Coupons</h2>
            <Card>
                <CardHeader>
                    <CardTitle>Coupon Management</CardTitle>
                </CardHeader>
                <CardContent>
                    <p className="text-muted-foreground">Coupon management interface will be implemented here.</p>
                </CardContent>
            </Card>
        </div>
    );
}
